import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from 'lucide-react';
import { NavigationDirection } from './types';
import React from 'react';

interface NavigationArrowsProps {
  canNavigateForward: boolean;
  canNavigateBackward: boolean;
  canNavigateLeft: boolean;
  canNavigateRight: boolean;
  navigationDisabled: boolean;
  handleNavigate: (direction: NavigationDirection) => void;
}

const NavigationArrows = ({ 
  canNavigateForward,
  canNavigateBackward, 
  canNavigateLeft, 
  canNavigateRight,
  navigationDisabled,
  handleNavigate 
}: NavigationArrowsProps) => {
  if (navigationDisabled) return null;

  return (
    <div className="absolute inset-0 pointer-events-none">
      {/* Forward arrow */}
      {canNavigateForward && (
        <button
          onClick={() => handleNavigate("forward")}
          className="absolute top-[calc(50%-80px)] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 pointer-events-auto hover:scale-110 border border-gray-200"
          title="Vorwärts (W / ↑)"
        >
          <ArrowUp size={24} />
        </button>
      )}

      {/* Backward arrow */}
      {canNavigateBackward && (
        <button
          onClick={() => handleNavigate("backward")}
          className="absolute top-[calc(50%+80px)] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 pointer-events-auto hover:scale-110 border border-gray-200"
          title="Rückwärts (S / ↓)"
        >
          <ArrowDown size={24} />
        </button>
      )}

      {/* Left arrow */}
      {canNavigateLeft && (
        <button
          onClick={() => handleNavigate("left")}
          className="absolute top-1/2 left-[calc(50%-80px)] transform -translate-x-1/2  -translate-y-1/2  bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 pointer-events-auto hover:scale-110 border border-gray-200"
          title="Links (A / ←)"
        >
          <ArrowLeft size={24} />
        </button>
      )}

      {/* Right arrow */}
      {canNavigateRight && (
        <button
          onClick={() => handleNavigate("right")}
          className="absolute top-1/2 left-[calc(50%+80px)] transform -translate-x-1/2  -translate-y-1/2  bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 p-3 rounded-full shadow-lg transition-all duration-200 pointer-events-auto hover:scale-110 border border-gray-200"
          title="Rechts (D / →)"
        >
          <ArrowRight size={24} />
        </button>
      )}
    </div>
  );
};

export default NavigationArrows;
